import i18n from "@/i18n";

export const contractFields = [
    {
        key: "name",
        label: i18n.t("solution.title"),
        sortable: true
    },
    {
        key: "actions",
        label: ""
    }
];
